module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/typography/text-tranform/text-tranform.component.scss
// module id = ./src/app/features/typography/text-tranform/text-tranform.component.scss
// module chunks = main